var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('ul',{staticClass:"nav"}),_c('div',{staticClass:"copyright"},[_vm._v(" © "+_vm._s(_vm.year)+" OPA Technologies ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }